import { render, staticRenderFns } from "./ApproveTable.pug?vue&type=template&id=5930f2b2&scoped=true&lang=pug&"
import script from "./ApproveTable.vue?vue&type=script&lang=js&"
export * from "./ApproveTable.vue?vue&type=script&lang=js&"
import style0 from "./ApproveTable.scss?vue&type=style&index=0&id=5930f2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930f2b2",
  null
  
)

export default component.exports